import { createFileRoute } from '@tanstack/react-router';
import { StationGate } from '../station/station-gate.js';

export const Route = createFileRoute('/_station')({
  component: StationGate,
});
